import {API_URL, THEME_COLOR, numberWithCommas, getDate} from "../constant"
import React, {useEffect, useState} from 'react';
import HeaderBack from "../layout/HeaderBack";
import "./HistoryTransaction.css";
import {jQuery as $} from "jquery";
import { useLocalStorage } from "../useLocalStorage";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';

import banner1 from "../logo.svg"

import { useHistory } from "react-router";



const DetailHistoryTransaction = (props)=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [headertransaction, setHeaderTransaction] = useState({});
    const [detailransaction, setDetailTransaction] = useState([]);


    function getTransaction(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/transaction/${props.match.params.id}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));
    }

    useEffect(async ()=>{
        // console.log(props)
        let response = await getTransaction();
        if(response.status == 200){
            setHeaderTransaction(response.data.headerdata)
            setDetailTransaction(response.data.detaildatas)
        }else{
            toast.error(response.message)
        }
    },[])


    if(token){
        return(
            <React.StrictMode>
                <Toaster
                    position="bottom-center"
                />
                <HeaderBack title="Detail" />
                <div className="history-container">
                    <div className="history-card">
                        <div className="history-flex-container">
                            <div className="history-image-container" style={{display:"none"}}>
                                <img src={banner1} />
                            </div>
                            <div className="history-card-detail">
                                <div className="history-item-name">{headertransaction.Code}</div>
                                {/* <div style={{fontSize: "10pt"}}>Qty : 1</div> */}
                                    <div style={{fontSize: "10pt"}}>Status : {
                                        (headertransaction.Status == 1)?(
                                            <span className="history-status green accent-3">Success</span>
                                        ):(
                                            <span className="history-status yellow accent-3">Pending</span>
                                        )
                                    }</div>
                                <div style={{fontSize: "8pt",color:"gray"}}>{getDate(new Date(headertransaction.SysDate))}</div>
                            </div>
                        </div>
                        <div className="history-flex-container">
                            <div className="history-card-price">
                                <div className="history-grandtotal">Grand Total</div>
                                <div className="history-amount">Rp {numberWithCommas(headertransaction.GrandTotal)}</div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="history-card">
                        <div style={{fontWeight:"bold", fontSize:"20pt"}}>Detail</div>
                        <div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Qty</th>
                                        <th>Price</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        detailransaction.map((value, index)=>{
                                            return(
                                                <tr>
                                                    <td>{ parseInt(index) + 1}</td>
                                                    <td>{value.ItemName}</td>
                                                    <td>{value.Qty}</td>
                                                    <td>Rp. {numberWithCommas(value.Price)}</td>
                                                    <td>Rp. {numberWithCommas(value.SubTotal)}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </React.StrictMode>
        );
    }else{
        return(
            <React.StrictMode>
                <Toaster
                    position="bottom-center"
                />
                <HeaderBack title="Detail" />
            </React.StrictMode>
        );
    }

}


export default DetailHistoryTransaction;
